<template>
  <div class="project">
    <div class="project-top">
      <div class="header el-col el-col-24">
        <div class="wrapper">
          <div class="content">
            <div class="project-name">山西省第三届家庭教育指导技能大赛（社会成人）</div>
            <div class="info-content">
              <div class="class-name">太原市赛区</div>
              <div>项目时间：
                2025-05-07 至2025-09-28
              </div>
            </div>
          </div>
          <div class="tab_content"></div>
        </div>
      </div>
      <div class="menu">
        <div class="item" :class="[tabActive===0?'link-active':'']" @click="tabFun(0)">
          <img src="https://www.ttcdw.cn/p/uc/static/img/menu_one.70c1d71.png">
          <div class="menu_name">
            我的课堂
          </div>
        </div>
        <div class="item" :class="[tabActive===1?'link-active':'']" @click="tabFun(1)">
          <img src="https://www.ttcdw.cn/p/uc/static/img/menu_two.402af27.png">
          <div class="menu_name">
            学习档案
          </div>
        </div>
        <div class="item" :class="[tabActive===2?'link-active':'']" @click="tabFun(2)">
          <img src="https://www.ttcdw.cn/p/uc/static/img/menu_three.acc0bf6.png">
          <div class="menu_name">
            公告通知
          </div>
        </div>
      </div>
    </div>
    <!-- 我的课堂 -->
    <myclassroom v-if="tabActive===0"></myclassroom>
    <!-- 学习档案 -->
    <studentfiles v-if="tabActive===1"></studentfiles>
    <!-- 公告通知 -->
    <notice v-if="tabActive===2"></notice>
  </div>
</template>


<script>
import myclassroom from './component/myclassroom.vue';
import studentfiles from './component/studentfiles.vue';
import notice from './component/notice.vue';
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      tabActive: 0
    }
  },
  components: {
    myclassroom,
    studentfiles,
    notice
  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },
  computed: {

  },
  methods: {
    tabFun(index) {
      this.tabActive = index
    }

  },

}
</script>
<style lang="scss" scoped>
.project {
  width: 100%;
  position: relative;
  margin-bottom: 35px;
  background-color: #F7F8FA;
  min-height: calc(100vh - 70px);
  .project-top {
    position: relative;
    width: 100%;
    height: 242px;
    margin-bottom: 40px;

    .header {
      background: url('https://www.ttcdw.cn/p/uc/static/img/headerBg.a5211c3.png') no-repeat;
      height: 242px;
      background-size: 100% 100%;
      z-index: 200;

      .wrapper {
        max-width: 1200px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .content {
          flex: 1;

          .project-name {
            font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
            font-weight: 800;
            font-size: 40px;
            color: #1E51DC;
            line-height: 48px;
            margin-bottom: 17px;
            text-shadow: 0px 1px 2px rgba(0, 90, 55, 0.3);
            -webkit-text-stroke: 1px rgba(25, 165, 111, 0.4);
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }

          .info-content {
            background: url(/p/uc/static/img/shade_bg.d53f3c4.png) no-repeat;
            background-size: 100%;
            text-align: left;
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 19px;
            padding: 10px 21px;
            display: inline-block;

            .class-name {
              margin-bottom: 10px;
            }
          }
        }

        .tab_content {}
      }
    }

    .el-col-24 {
      width: 100%;
    }

    .menu {
      background: url('https://www.ttcdw.cn/p/uc/static/img/menuBg.d1c4639.png') no-repeat;
      background-size: 100% 100%;
      width: 1216px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      position: absolute;
      left: 50%;
      margin-left: -608px;
      bottom: -35px;



      .item {
        margin-right: 90px;
        font-weight: 400;
        color: #3B70FF;
        font-size: 18px;
        cursor: pointer;
        display: flex;
        line-height: 25px;
        align-items: center;

        img {
          width: 21px;
          height: 19px;
          margin-right: 10px;
        }

        .menu_name {
          padding: 20px 0px;
        }
      }

      .link-active {
        color: #3B70FF;
        font-weight: 600;
        position: relative;

        &:after {
          content: "";
          position: absolute;
          width: 100%;
          height: 4px;
          background-color: #3B70FF;
          left: 0;
          bottom: 10px;
        }
      }
    }
  }

}
</style>
